/** Елемент списку, по якому гортає переглядач: папки пропускаємо. */
export interface DiskViewerSibling {
    uuid: string
    type: 'folder' | 'file'
}

export interface DiskAdjacentFiles {
    prev: string | null
    next: string | null
    /** Номер файлу серед файлів списку, від 1; `0` — файла в списку немає. */
    position: number
    /** Скільки файлів (без папок) у списку. */
    count: number
}

/**
 * Попередній і наступний файл у порядку списку (як їх бачить людина),
 * пропускаючи папки. На краях списку переходу немає — без «закільцювання»,
 * щоб останній файл не відкривав раптом перший.
 */
export const adjacentFiles = (items: readonly DiskViewerSibling[], uuid: string): DiskAdjacentFiles => {
    const files = items.filter((item) => item.type === 'file')
    const index = files.findIndex((item) => item.uuid === uuid)

    if (index < 0) return { prev: null, next: null, position: 0, count: files.length }

    return {
        prev: files[index - 1]?.uuid ?? null,
        next: files[index + 1]?.uuid ?? null,
        position: index + 1,
        count: files.length,
    }
}
